import * as React from 'react';

import { cn } from '@/utils/cn';
import { Slot } from '@radix-ui/react-slot';

import { type VariantProps } from 'class-variance-authority';

import { buttonVariants } from '@/components/ui/button-variants';

declare global {
  interface Window {
    gtag: any;
  }
}

export interface ButtonProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, onClick, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';

    // Function to handle button click event
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      // Track the button click event in Google Analytics
      if (window.gtag) {
        window.gtag('event', 'button_click', {
          event_category: 'Button',
          event_label: variant || 'Default Button'
        });
      }

      // Call the original onClick if provided
      if (onClick) {
        onClick(event);
      }
    };

    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
        onClick={handleClick}
      />
    );
  }
);
Button.displayName = 'Button';

export { Button };
